import { useRouter } from "next/router";
import { useEffect } from "react";

import { trackOpenAI } from "@/analytics/openai";
import { useConsentStore } from "@/consent/useConsentStore";

/**
 * Fires `page_viewed` on every page, client-side navigations included.
 * Sits after ConsentScripts so the pixel exists by the first effect.
 */
export default function OpenAIPageView(): null {
  const router = useRouter();
  const marketing = useConsentStore((s) => s.consent.marketing);
  const path = router.asPath.split(/[?#]/)[0] ?? "/";

  useEffect(() => {
    if (!marketing || !router.isReady) return;
    trackOpenAI("page_viewed", () => ({
      type: "contents",
      contents: [{ id: path, name: path, content_type: "page" }],
    }));
  }, [marketing, router.isReady, path]);

  return null;
}
